import { render, staticRenderFns } from "./MotoList.vue?vue&type=template&id=4f0f8472&scoped=true&"
import script from "./MotoList.vue?vue&type=script&lang=js&"
export * from "./MotoList.vue?vue&type=script&lang=js&"
import style0 from "./MotoList.vue?vue&type=style&index=0&id=4f0f8472&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0f8472",
  null
  
)

component.options.__file = "MotoList.vue"
export default component.exports